import { Platform } from 'react-native';

const fontFamily = Platform.select({
  ios: 'System',
  android: 'sans-serif',
  default: 'System',
});

export const typography = {
  screenTitle: {
    fontFamily,
    fontSize: 28,
    lineHeight: 36,
    fontWeight: '700' as const,
  },
  sectionTitle: {
    fontFamily,
    fontSize: 18,
    lineHeight: 26,
    fontWeight: '600' as const,
  },
  body: {
    fontFamily,
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '400' as const,
  },
  caption: {
    fontFamily,
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '400' as const,
  },
  button: {
    fontFamily,
    fontSize: 16,
    lineHeight: 22,
    fontWeight: '600' as const,
  },
  input: {
    fontFamily,
    fontSize: 16,
    lineHeight: 22,
    fontWeight: '400' as const,
  },
};
